// Note: Global Components
import React, {useState} from 'react';
import {Dialog} from '@rneui/themed';
import {Text, View} from 'react-native';
import {DialogLoading as LoadingIcon} from '@rneui/base/dist/Dialog/Dialog.Loading';
import {createStyles} from '../../utils/createStyles';

export type LoadingProps = {
  text?: string;
};

export let showGlobalLoading: (setting: LoadingProps) => void = () => {};
export let hideGlobalLoading: () => void = () => {};

export default function GlobalLoading() {
  const [loadingVisible, setLoadingVisible] = useState(false);
  const [loadingText, setLoadingText] = useState('');
  const showGlobalLoadingMethod = (setting: LoadingProps) => {
    setLoadingText(setting.text || '加载中');
    setLoadingVisible(true);
  };
  const hideGlobalLoadingMethod = () => {
    setLoadingText('');
    setLoadingVisible(false);
  };
  showGlobalLoading = showGlobalLoadingMethod;
  hideGlobalLoading = hideGlobalLoadingMethod;
  return (
    <>
      <Dialog
        overlayStyle={loadingStyle.overlayStyle}
        isVisible={loadingVisible}
        supportedOrientations={['landscape', 'portrait']}
        transparent
        statusBarTranslucent={true}>
        <View style={loadingStyle.loadingView}>
          <LoadingIcon />
          {loadingText ? (
            <Text style={loadingStyle.loadingText}>{loadingText}</Text>
          ) : null}
        </View>
      </Dialog>
    </>
  );
}

const loadingStyle = createStyles({
  overlayStyle: {
    flexDirection: 'row',
    justifyContent: 'center',
    backgroundColor: 'transparent',
    elevation: 0,
    shadowColor: 'transparent',
  },
  backdropStyle: {
    width: '100%',
  },
  loadingView: {
    width: '20%',
    borderRadius: '0.5rem',
    paddingBottom: '1rem',
    backgroundColor: '#fff',
    textAlign: 'center',
  },
  loadingText: {
    textAlign: 'center',
    fontSize: '1.2rem',
    color: '#333',
    marginTop: '0.5rem',
  },
});
